export default __webpack_public_path__ + "static/media/GitKraken-Logo.f76e4685.svg";